export const packages = {
  title: 'Pakiety',
  unlinkPackage: 'Usuń powiązanie',
  linkPackage: 'Przypisz pakiet',
  deletePackage: 'Usuń pakiet',
  editPackage: 'Edytuj pakiet',
  linkPackages: 'Podejrzyj możliwe powiązania',
  addPackage: 'Dodaj pakiet',
  noPackagesAvailable:
    'Brak pakietów dostępnych do powiązania. Stwórz nowy pakiet, aby móc go powiązać.',
} as const
